import * as angular from 'angular';
import controller, {CavityEfficiencyGraphController} from './cavityEfficiencySummaryGraph.controller';
import template from './cavityEfficiencySummaryGraph.tpl.html';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

export interface CavityEfficiencySummaryGraphScope extends angular.IScope {
  vm: CavityEfficiencyGraphController;
}

function cavityEfficiencySummaryGraphDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'CavityEfficiencySummaryGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      cavities: '=',
      cavitySelected: '=',
      showIfEmpty: '='
    },
    link: function ($scope: CavityEfficiencySummaryGraphScope) {
      $scope.$watchCollection('vm.cavities', function(newVal: apsViewModels.CavityCountSummary[]) {
        $scope.vm.setCavities(newVal);
      });
    }
  };
}

export default angular.module('aps.directive.cavityEfficiencySummaryGraph', [controller])
	.directive('apsCavityEfficiencySummaryGraph', cavityEfficiencySummaryGraphDef)
	.name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/cavityEfficiencySummaryGraph.directive.ts